import React from "react";
import { UseAgentTestLab } from "./useAgentTestLab";

interface TabStripProps {
  lab: UseAgentTestLab;
}

interface TabDef {
  id: "scenarios" | "runs" | "optimizer";
  label: string;
  count?: number;
  showDot?: boolean;
  hidden?: boolean;
}

export const TabStrip: React.FC<TabStripProps> = ({ lab }) => {
  const tabs: TabDef[] = [
    {
      id: "scenarios",
      label: "Scenarios",
      count: lab.scenarios.length,
    },
    {
      id: "runs",
      label: "Runs",
      count: lab.runs.length,
    },
    {
      id: "optimizer",
      label: "Optimizer",
      hidden: !lab.optimizerVisible,
      showDot: lab.hasUnreviewedCandidate,
    },
  ];

  return (
    <div
      role="tablist"
      className="flex items-end gap-1 border-b border-[var(--border)] -mb-px"
    >
      {tabs
        .filter((tab) => !tab.hidden)
        .map((tab) => {
          const active = lab.activeTab === tab.id;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={active}
              type="button"
              onClick={() => lab.setActiveTab(tab.id)}
              className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors inline-flex items-center gap-2 ${
                active
                  ? "border-[var(--accent)] text-[var(--foreground)]"
                  : "border-transparent text-[var(--foreground-muted)] hover:text-[var(--foreground)]"
              }`}
            >
              <span>{tab.label}</span>
              {typeof tab.count === "number" && (
                <span
                  className={`text-xs px-1.5 py-0.5 rounded ${
                    active
                      ? "bg-[var(--accent)]/15 text-[var(--accent)]"
                      : "bg-[var(--muted)] text-[var(--foreground-muted)]"
                  }`}
                >
                  {tab.count}
                </span>
              )}
              {tab.showDot && (
                <span
                  aria-hidden="true"
                  className="h-2 w-2 rounded-full bg-[var(--accent)] animate-pulse"
                />
              )}
            </button>
          );
        })}
    </div>
  );
};
